<!--<app-project-map-->
<!--  [mapLayers]="mapLayers"-->
<!--  [dailyReports]="dailyReports"-->
<!--  [project]="project"-->
<!--  [isFullScreen]="mapFullScreen"-->
<!--  (toggleMapFullScreen)="toggleMapFullScreen()"-->
<!--  [class.map-full-screen]="mapFullScreen"-->
<!--&gt;</app-project-map>-->

@if (initialized) {
  <div class="page-content">
    <!-- Project details -->
    <app-project-card [project]="project" [showProgress]="false" picHeight="90px"></app-project-card>
    <!-- Date tabs -->
    <nav mat-tab-nav-bar class="sub-nav">
      @for (date of dates; track date; let i = $index) {
        <a mat-tab-link [routerLink]="['../', date.format('YYYY-MM-DD')]"
        [active]="date.isSame(reportDate, 'day')">{{date | dateFormat: 'first-long-short': i }}</a>
      }
      <a mat-tab-link>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
        <input matInput style="width: 0; visibility: hidden;" [matDatepickerFilter]="projectDates"
          [matDatepicker]="picker" (ngModelChange)="datePicked($event)" [(ngModel)]="pickedDate" />
      </a>
    </nav>
    <!-- /Date tabs -->
    <!-- Tab Content -->
    <div class="tab-content">
      @if (projectReport?.id) {
        <div class="stroked-card">
          <!-- Todo Missing/incorrect typography: 18/24 700-->
          <div class="mat-subtitle-1">Project report</div>
          <div class="mat-subtitle-1 panel-indicator" (click)="showConsolidatedReport = !showConsolidatedReport"
            [class.open]="showConsolidatedReport" [class.close]="!showConsolidatedReport">View consolidated daily report
          </div>
        </div>
        @if (showConsolidatedReport) {
          <div class="report-panel">
            <!-- Project report status -->
            <ng-container *ngTemplateOutlet="projectReportStatus"></ng-container>
            <!-- Project report status -->
            <app-project-consolidated-report
              [editable]="true"
              [dailyReports]="dailyReports"
              [showConsolidatedReport]="showConsolidatedReport"
              />
            <div class="form-actions">
              <!-- Create project report as draft if it is not done yet -->
              @if (!projectReport?.id && ('create' | able: projectReport)) {
                <button mat-flat-button color="primary"
                (click)="saveReport()">Save</button>
              }
              <!-- Show workflow actions for project report -->
              @if (projectReport?.id && ('read' | able: projectReport)) {
                <app-workflow wf="project-report-approval" [id]="projectReport.id" [projectId]="project.id"
                [redraw]="projectReport.status" (actionResponse)="projectReportChanged($event)"></app-workflow>
              }
            </div>
          </div>
        }
      }
      <!-- /sites-list -->
      @if (!showConsolidatedReport) {
        @for (site of sitesList; track site) {
          <section class="site-section">
            <div class="site-title">Site {{site.name}}</div>
            <div class="status-container">
              @if (dailyReports | filter: 'site_id': site.id; as drs) {
                @if (!drs.length) {
                  <div class="status-card">
                    <div class="mat-body">
                      Awaiting creation
                      <a mat-button color="primary" [disabled]="!('create' | able: site.newDR)"
                        [routerLink]="['../../daily-report/create']"
                      [queryParams]="{siteId: site.id, date: reportDate.format('YYYY-MM-DD')}">Create Report</a>
                    </div>
                  </div>
                }
                @for (dr of drs; track dr) {
                  <div class="status-card" [routerLink]="['../../', 'daily-report', dr.id]"
                    [class.active]="dr.status == 'approved'" [class.error]="dr.status == 'rejected'">
                    <div class="mat-subtitle-1">
                      {{dr.createdBy?.name}}
                    </div>
                    <div class="mat-caption">
                      Received at {{dr.created_at | date: 'shortTime'}}
                    </div>
                    <div class="mat-body">
                      @switch (dr.status) {
                        @case ('todo') {
                          Awaiting creation
                        }
                        @case ('draft') {
                          Awaiting submission
                        }
                        @case ('submitted') {
                          Awaiting approval
                        }
                        @case ('reviewed') {
                          Awaiting approval
                        }
                        @case ('rejected') {
                          Rejected
                        }
                        @case ('approved') {
                          Approved
                        }
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </section>
        }
      }
      <!-- /sites-list -->
    </div>
    <!-- /Tab Content -->
    <!-- /Report view -->
  </div>
}


<ng-template #projectReportStatus>
  @if (!projectReport?.lastApprovalAction && projectReport?.status == 'draft') {
    <div>
      Draft by {{projectReport.createdBy?.name}}
      <span class="mat-caption">on {{projectReport.created_at | dateFormat: 'very-long'}}</span>
    </div>
  }

  @if (projectReport?.lastApprovalAction?.id) {
    <div>
      {{projectReport.lastApprovalAction?.state?.comment}} by {{projectReport.lastApprovalAction?.actor?.name}}
      <span class="mat-caption">on {{projectReport.lastApprovalAction?.created_at | dateFormat: 'very-long'}}</span>
    </div>
  }
</ng-template>
